import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { DE$ } from '@infl-ts/util-datum';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useLazyUnlockedAndSuggestedChallenges, useUnlockedAndSuggestedChallenges } from './queries';

var recommended = function recommended(_ref) {
  var unlockedChallenges = _ref.unlockedChallenges,
      suggestedChallenges = _ref.suggestedChallenges;
  return unlockedChallenges && unlockedChallenges.length > 0 ? {
    type: 'unlocked',
    challenges: unlockedChallenges
  } : {
    type: 'suggested',
    challenges: suggestedChallenges !== null && suggestedChallenges !== void 0 ? suggestedChallenges : []
  };
};

var convertToRecommendedDatumEither = function convertToRecommendedDatumEither(unlockedAndSuggestedChallenges) {
  if (DE.isInitial(unlockedAndSuggestedChallenges) || DE.isPending(unlockedAndSuggestedChallenges)) return unlockedAndSuggestedChallenges;
  return pipe(unlockedAndSuggestedChallenges, function (x) {
    return x.value;
  }, E.matchW(DE.failure, flow(recommended, DE.success)));
};

var prefetchedChallenges = function prefetchedChallenges(completeStageStatus) {
  return pipe(completeStageStatus, O.fromPredicate(DE.isSuccess), O.map(function (x) {
    return x.value.right;
  }), O.filterMap(function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteChallengeResult' ? O.some({
      unlockedChallenges: completeStage.unlockedChallenges,
      suggestedChallenges: completeStage.suggestedChallenges
    }) : O.none;
  }), O.toNullable);
};

var useRecommendedChallenges = function useRecommendedChallenges(_ref3) {
  var challengeId = _ref3.challengeId,
      completeStageStatus = _ref3.completeStageStatus;
  return pipe(prefetchedChallenges(completeStageStatus), function (prefetched) {
    return {
      prefetched: prefetched,
      // eslint-disable-next-line react-hooks/rules-of-hooks
      fetched: useUnlockedAndSuggestedChallenges({
        variables: {
          challengeId: challengeId,
          unlockedFirst: 4
        },
        skip: prefetched !== null
      }).result,
      // eslint-disable-next-line react-hooks/rules-of-hooks
      fetchMore: useLazyUnlockedAndSuggestedChallenges({
        variables: {
          challengeId: challengeId,
          unlockedFirst: 100
        }
      })
    };
  }, function (_ref4) {
    var prefetched = _ref4.prefetched,
        fetched = _ref4.fetched,
        _ref4$fetchMore = _slicedToArray(_ref4.fetchMore, 2),
        fetchMoreUnlocked = _ref4$fetchMore[0],
        fetchMoreResult = _ref4$fetchMore[1];

    return {
      recommendedChallenges: pipe(fetchMoreResult, DE$.altSuccess(function () {
        return DE.fromNullable(prefetched);
      }), DE$.altSuccess(function () {
        return fetched;
      }), convertToRecommendedDatumEither),
      fetchMoreUnlocked: fetchMoreUnlocked
    };
  });
};

export default useRecommendedChallenges;